// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!/Users/chris/IdeaProjects/Guardian-Anglo/node_modules/css-loader/index.js!/Users/chris/IdeaProjects/Guardian-Anglo/node_modules/sass-loader/index.js!/Users/chris/IdeaProjects/Guardian-Anglo/src/app/sass/main.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!/Users/chris/IdeaProjects/Guardian-Anglo/node_modules/style-loader/addStyles.js")(content, {});
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	module.hot.accept("!!/Users/chris/IdeaProjects/Guardian-Anglo/node_modules/css-loader/index.js!/Users/chris/IdeaProjects/Guardian-Anglo/node_modules/sass-loader/index.js!/Users/chris/IdeaProjects/Guardian-Anglo/src/app/sass/main.scss", function() {
		var newContent = require("!!/Users/chris/IdeaProjects/Guardian-Anglo/node_modules/css-loader/index.js!/Users/chris/IdeaProjects/Guardian-Anglo/node_modules/sass-loader/index.js!/Users/chris/IdeaProjects/Guardian-Anglo/src/app/sass/main.scss");
		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
		update(newContent);
	});
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/sass/main.scss
 ** module id = 6
 ** module chunks = 0
 **/